<template>
    <div>
        <div
            v-if="
                !data.cluster.workspace_slug ||
                !data.cluster.repository_slug
            "
        >
            <p class="bg-red-100 p-3 border-red-400 border rounded-md">
                You need to add the GitHub workspace and repo slug for the
                <a
                    :href="route('clusters.edit', data.cluster)"
                    target="_blank"
                    class="text-blue-600 hover:text-blue-400"
                >cluster</a> before you can build the front end.
            </p>
        </div>

        <div v-for="(site, index) in data.sites" class="mb-4">
            <div v-if="data.cluster.workspace_slug && data.cluster.repository_slug">
                <form
                    :action="route('clusters.build', [data.cluster, site])"
                    method="POST"
                    class="mb-2"
                >
                    <input type="hidden" name="_token" :value="csrf"/>
                    <Btn :key="`site-${index}`"
                         :content="`Build ${site.domain}`"
                         :disabled-content="`Building ${site.domain}`"
                         :disabled="site.isBuildDisabled"
                    />
                </form>
            </div>

            <p v-if="site.pipeline_last_run" class="text-blue-600 dark:text-blue-300">
                <span class="font-bold">⏰ Last update:</span> {{ site.pipeline_last_run }}
            </p>

            <p v-if="site.pipelineCompleted" :key="`site-${index}`" class="text-green-600 dark:text-green-300">
                <span class="font-bold">🎉 {{ site.domain }}</span> has been built!
            </p>

            <p v-if="site.pipelineFailed" :key="`site-${index}`" class="text-red-600 dark:text-red-300">
                😢 There was an error with checking the pipeline's status
            </p>
        </div>
    </div>
</template>

<script>
import csrf from '../mixins/csrf'

export default {
    name: 'BuildFrontEnd',
    mixins: [csrf],
    props: {
        cluster: Object,
    },
    data() {
        return {
            data: this.updateDefaultData(this.cluster),
            isPipelineUrlAvailable:
                this.cluster.workspace_slug !== '' &&
                this.cluster.repository_slug !== '',
        }
    },
    mounted: function () {
        for (let i = 0; i < this.data.sites.length; i++) {
            if (this.data.sites[i].isBuildDisabled && this.isPipelineUrlAvailable) {
                this.checkPipelineProgress(i);
            }
        }
    },
    methods: {
        checkPipelineProgress: function (siteIndex) {
            const check = setInterval(() => {
                axios
                    .post(route('clusters.status', [this.data.cluster, this.data.sites[siteIndex]]))
                    .then((response) => {
                        if (response.data.status === 'success') {
                            Object.assign(this.data.sites[siteIndex], {isBuildDisabled: false});
                            Object.assign(this.data.sites[siteIndex], {pipelineCompleted: true});
                            Object.assign(this.data.sites[siteIndex], {pipelineFailed: false});

                            clearInterval(check)
                        }

                        if (
                            response.data.status !== 'success' &&
                            response.data.status !== 'in_progress'
                        ) {
                            Object.assign(this.data.sites[siteIndex], {isBuildDisabled: false});
                            Object.assign(this.data.sites[siteIndex], {pipelineCompleted: false});
                            Object.assign(this.data.sites[siteIndex], {pipelineFailed: true});

                            clearInterval(check)
                        }
                    })
                    .catch((error) => {
                        console.error(error)

                        Object.assign(this.data.sites[siteIndex], {isBuildDisabled: false});
                        Object.assign(this.data.sites[siteIndex], {pipelineCompleted: false});
                        Object.assign(this.data.sites[siteIndex], {pipelineFailed: true});

                        clearInterval(check)
                    })
            }, 15000)
        },
        updateDefaultData(cluster) {
            return {
                cluster: cluster,
                sites: this.updateDefaultSites(cluster.sites),
            }
        },
        updateDefaultSites(sites) {
            for (let i = 0; i < sites.length; i++) {
                Object.assign(sites[i], {isBuildDisabled: this.checkIfBuildIsDisabled(i)});
                Object.assign(sites[i], {pipelineCompleted: false});
                Object.assign(sites[i], {pipelineFailed: false});
            }

            return sites;
        },
        checkIfBuildIsDisabled(siteIndex) {
            if (this.cluster.sites[siteIndex].pipeline_status === null) {
                return false
            }

            return (
                this.cluster.sites[siteIndex].pipeline_status !== 'completed' &&
                this.cluster.sites[siteIndex].pipeline_last_id !== ''
            )
        },
    },
}
</script>
